export enum Vertical {
  Gambling,
}
